import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import Comment from './Comment';
import { appendReplyCommentData, appendCommentsData } from './actions';
import ButtonAction from './ButtonAction';
import { selectComments, makeSelectLoadingAppend } from './selectors';
import LoadingSpinner from '~/components/loading-spinner/LoadingSpinner';

const ListComment = (props) => {
  const {
    data,
    appendReplyCommentData,
    appendCommentsData,
    commentsData,
    loadingAppendComment,
    t,
  } = props;
  const [comments, setComments] = useState([]);
  const [idCommentClick, setIdCommentClick] = useState(null);
  const [idReplyClick, setIdReplyClick] = useState(null);

  // useEffect(() => {
  //   setComments(data);
  // }, [data]);
  const onClickSeeMore = () => {
    appendCommentsData({
      data_id: commentsData.object_id,
      page: commentsData.page + 1,
    });
  };
  const { has_next } = commentsData;
  return (
    <div className="container-list-comment">
      {data.length > 0 &&
        data.map((comment, key) => (
          <Comment
            appendReplyCommentData={appendReplyCommentData}
            comment={comment}
            key={comment.id}
            idCommentClick={idCommentClick}
            setIdCommentClick={setIdCommentClick}
            idReplyClick={idReplyClick}
            setIdReplyClick={setIdReplyClick}
            t={t}
          />
        ))}
      {loadingAppendComment && <LoadingSpinner style={{ padding: '40px 0' }} />}
      {has_next && <ButtonAction onClickSeeMore={onClickSeeMore} />}
      <style jsx>{`
        .container-list-comment {
          display: flex;
          flex-direction: column;
          gap: 24px;
          margin-top: 24px;
        }
      `}</style>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  commentsData: selectComments,
  loadingAppendComment: makeSelectLoadingAppend(),
});

const mapDispatchToProps = (dispatch) => ({
  appendReplyCommentData: (params) => dispatch(appendReplyCommentData(params)),
  appendCommentsData: (query) => dispatch(appendCommentsData(query)),
});

const Connector = connect(mapStateToProps, mapDispatchToProps)(ListComment);

export default Connector;
